import { Phone } from "lucide-react";
import { RINGBA_DNI_PHONE } from "@/lib/constants";

export default function MobileHeaderCallButton() {
  return (
    <a
      href={`tel:${RINGBA_DNI_PHONE}`}
      className="flex md:hidden items-center justify-center w-9 h-9 rounded-full bg-[#090739] text-white hover:bg-[#090739]/80 transition-colors shrink-0"
      aria-label="Call us"
      suppressHydrationWarning={true}
    >
      <Phone className="h-4 w-4" />
    </a>
  );
}
